import ResumeDistributionView from './ResumeDistributionView'
export default ResumeDistributionView
